export const priceConfig = {
    monthlyTest: "price_1PdkswJCIpfsDplT4smayZIN",
    yearlyTest: "price_1PdkvkJCIpfsDplTrgotCyEr",
    monthlyLive: "price_1PqFceJCIpfsDplToGwEEWGn",
    yearlyLive: "price_1PqFceJCIpfsDplTPTiMBXgj",
};